/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeUsageGetComputeUsage } from "../../funcs/computeUsageGetComputeUsage.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetComputeUsageRequest$inboundSchema,
};

export const tool$computeUsageGetComputeUsage: ToolDefinition<typeof args> = {
  name: "compute-usage-get-compute-usage",
  description: `Get usage`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeUsageGetComputeUsage(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
